import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TelefonoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TELEFONO' htmlFor='input-telefono' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='telefono'>
          {({ field }) => (
            <Form.InputText
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-telefono'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TelefonoFormGroup)
